<template>
  <body class="az-body az-body-sidebar" >
    <Sidebar v-show="sidebar" />
      <div class="az-content az-content-dashboard-five">
        <Adviserheader />
        <keep-alive>
          <router-view>
          </router-view>
        </keep-alive>
        <Footer />
      </div>
  </body>
</template>
<script>
export default {
  name: 'components',
  components: {
    Sidebar : ()=>import('./Sidebar'),
    Adviserheader : ()=>import('./Adviserheader'),
    Footer : ()=>import('./Footer.vue'),
    // Modal,
    // AdviserPanel,
    // BOPanel
  },
  watch:{
    $route(to){
      this.changeInfo(to.path);
    },
    "$store.state.sidebar":{
      deep:true,
      handler:function(newVal,oldVal){
        this.sidebar = newVal
      }
    }
  },
  data(){
    return{
      isBO: false,
      isAdShow: true,
      isFundShow: false,
      brand: JSON.parse(localStorage.getItem('userdetail'))['brand_list'][0][1],
      sidebar:true
    }
  },
  created(){
    this.getBO();
  },
  methods:{
    getBO: function(){
        const userdetail = JSON.parse(localStorage.getItem('userdetail'));
        this.isBO = userdetail['isBO'];
    },
    changeInfo: function(path){
      if(path.includes('/funddashboard')){
        this.isAdShow = false;
        this.isFundShow = true;
      }else if(path=='/adviserdashboard'){
        this.isAdShow = true;
        this.isFundShow = false;
      }
    },
    
  }
  
  
}
</script>